import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Box, Button, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Select from "react-select";
import { axiosInstance } from "../../../utils/networking";
import { UserType } from "../../../interfaces";

interface WebIntakeAssignProps {
  setAssignToOpen: (open: boolean) => void;
  currUser: UserType;
  entryId: string;
}

const WebIntakeAssign = ({
  setAssignToOpen,
  currUser,
  entryId,
}: WebIntakeAssignProps) => {
  const navigate = useNavigate();

  const [clientList, setClientList] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState<{
    value: any;
    label: any;
  }>({
    value: currUser._id,
    label: currUser.firstName + " " + currUser.lastName,
  });

  useEffect(() => {
    axiosInstance.get(`/user/allUsers`).then((res) => {
      if (res.status === 200) {
        const users = res.data.users as UserType[];
        const userNames = users.map((user: any) => {
          return {
            label: user.firstName + " " + user.lastName,
            id: user._id,
          };
        });
        setClientList(
          userNames.sort((a, b) =>
            a.label > b.label ? 1 : b.label > a.label ? -1 : 0
          )
        );
      } else {
        console.log("API Error at getting survey result");
      }
    });
  }, []);

  const handleSelectChange = (selectedClient: any) => {
    setSelectedValue(selectedClient);
  };

  const handleSubmit = () => {
    const selectedSBCID = selectedValue.value;
    const selectedIntakeId = entryId;
    axiosInstance
      .post(`/webintake/assign`, {
        intakeId: selectedIntakeId,
        selectedSBCID: selectedSBCID,
      })
      .then((res) => {
        navigate("/case?id=" + res.data.caseId);
      });
  };

  return (
    <>
      <Box
        sx={{
          textAlign: "center",
          backgroundColor: "#9E1F63FF",
          padding: "3px",
          margin: 0,
          color: "white",
          borderRadius: "5px 5px 0 0",
        }}
      >
        <Typography sx={{ display: "inline-block" }} variant="h4">
          Assign Client
        </Typography>
        <Box
          sx={{ display: "inline", float: "right", cursor: "pointer" }}
          onClick={() => {
            setAssignToOpen(false);
          }}
        >
          <CloseIcon sx={{ fontSize: 40 }}></CloseIcon>
        </Box>
      </Box>
      <div className="w-full h-full flex flex-col items-center ">
        <div className="mt-[20%]">
          <Select
            value={selectedValue}
            onChange={handleSelectChange}
            className="w-[400px]"
            placeholder="Select the Client"
            options={clientList.map((client) => ({
              value: client.id,
              label: client.label,
            }))}
            styles={{
              control: (provided, state) => ({
                ...provided,
                height: "50px",
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? "#9D2362" : "white",
                color: state.isSelected ? "white" : "black",
                ":hover": {
                  backgroundColor: state.isSelected ? "#9D2362" : "#F3F4F6",
                },
              }),
            }}
          />
        </div>
        <div className="mt-3">
          <Button
            variant="contained"
            sx={{
              width: "200px",
              fontSize: "20px",
              backgroundColor: "#9E1F63FF",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
};
export default WebIntakeAssign;
